import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

import FORMATS from '../utils/formats';

function InputCreditCard(props) {
  const { name, inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      format={FORMATS.CREDIT_CARD}
      getInputRef={inputRef}
      isNumericString
      mask="#"
      onValueChange={({ value }) => {
        onChange({
          target: {
            name,
            value,
          },
        });
      }}
    />
  );
}

InputCreditCard.propTypes = {
  name: PropTypes.string,
  inputRef: PropTypes.any,
  onChange: PropTypes.func,
};

export default InputCreditCard;
